import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ServiceState } from "./services.entity";
import { deleteService, fetchServices, insertService, saveServicePrices } from "./services.api";
import { Service } from "@/models/services.model";
import { uuid } from "@/interfaces";
import type { ServicePriceChange } from "@shyne/shared/api";

export const getServices = createAsyncThunk("services/get", fetchServices);

export const createService = createAsyncThunk("service/create", async (values: Partial<Service>) =>
  insertService(values)
);

export const saveServicePricesThunk = createAsyncThunk("service/prices", async (changes: ServicePriceChange[]) => saveServicePrices(changes));

export const deleteServices = createAsyncThunk("service/delete", async (id: uuid) => {
  await deleteService(id);
  return id;
});

const initialState: ServiceState = {
  list: [],
  loading: false,
  total: 0,
  selectedService: null,
  selectDeleteService: null,
};

const servicesSlice = createSlice({
  name: "services",
  initialState,
  reducers: {
    setSelectedService: (state, action) => {
      state.selectedService = action.payload;
    },
    setSelectDeleteService: (state, action) => {
      state.selectDeleteService = action.payload;
    },
    addOptimisticlly: (state, action) => {
      state.list = [...state.list, action.payload];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getServices.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServices.fulfilled, (state, action) => {
        state.list = action.payload.data;
        state.total = action.payload.count;
        state.loading = false;
      })
      .addCase(getServices.rejected, (state) => {
        state.loading = false;
        state.selectedService = null;
      })
      .addCase(saveServicePricesThunk.fulfilled, (state, action) => {
        for (const saved of action.payload) {
          const index = state.list.findIndex((s) => s.id === saved.id);
          if (index !== -1) state.list[index] = saved;
        }
      })
      .addCase(deleteServices.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteServices.fulfilled, (state) => {
        state.loading = false;
        state.selectDeleteService = null;
      });
  },
});

export const { setSelectedService, setSelectDeleteService, addOptimisticlly } = servicesSlice.actions;

export default servicesSlice.reducer;
